import React, {Component} from 'react';
import {connect} from 'react-redux';
import { clone } from '../../../shared/services/lodashInJS.js';
import {toastr} from 'react-redux-toastr';

import {submitUser, submitFreelance} from './submit.js';
import {redirectToNotFound} from '../Errors/actions.js';
import {generate} from "../../routes";

export const SUCCESS_STATUS = 'success'

const successMessage = 'Les modifications ont correctement été enregistrées';

class StrategyFreelanceContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return !nextProps.loading;
  }

  /**
   * @param values
   * @returns {Promise.<void>}
   */
  submit = async (values) => {
    const {user, freelance, shouldStopRefresh, submitInterview, silentMode} = values;
    let _freelance, _user = null;

    if (freelance) {
      if(freelance.agent) {
        delete freelance.agent
      }
      try {
        _freelance = (await this.submitFreelance(freelance, submitInterview)).data;
      } catch (e) {
        toastr.error('Le freelance n\'a pas pu être modifié', {timeOut: 0});
      }
    }

    if (user) {
      try {
        _user = (await this.submitUser(user)).data;
      } catch (e) {
        toastr.error('Le user n\'a pas pu être modifié', {timeOut: 0});
      }
    }

    if ((_freelance || _user)) {
      if(!shouldStopRefresh) {
        this.refresh({
          freelance: _freelance,
          user: _user,
        });
      }
      if (silentMode !== true) {
        toastr.success(successMessage);
      }
      return {status: SUCCESS_STATUS}
    }
  };

  /**
   * @param values
   * @returns {Promise.<void>}
   */
  submitUserFreelance = async (values) => {
    const {user, freelance} = values;
    let _freelance, _user = null;

    if (user) {
      try {
        _user = (await this.submitUser(user)).data;
      } catch (e) {
        toastr.error('Le user n\'a pas pu être modifié', {timeOut: 0});
      }
    }

    if (freelance) {
      try {
        _freelance = (await this.submitFreelance(freelance)).data;
      } catch (e) {
        toastr.error('Le freelance n\'a pas pu être modifié', {timeOut: 0});
      }
    }

    if (_freelance || _user) {
      this.refresh({
        freelance: _freelance,
        user: _user,
      });
      toastr.success(successMessage);
      return {status: SUCCESS_STATUS}
    }
  };

  /**
   * @param values
   */
  refresh = (values) => {
    const profile = {
      user: this.props.profile.user,
      freelance: this.props.profile.freelance
    };

    if (values.freelance) {
      profile.freelance = values.freelance;
    }

    if (values.user) {
      profile.user = values.user;
    }

    if (this.props.refresh) {
      this.props.refresh(profile);
    }
  };

  /**
   * @param values
   * @returns {Promise.<*>}
   */
  submitUser = async (values) => {
    const user = this.liftUser(values);
    const newValues = {
      user: this.props.profile.user.id,
      ...user
    };

    return await submitUser(newValues);
  };

  liftUser = (_user) => {
    const user = clone(_user);
    user.city = user.city && user.city[0] ? user.city[0].id : null;

    return user;
  };

  submitFreelance = async (values, submitInterview = false) => {
    values.freelance = this.props.profile.freelance.id

    return await submitFreelance(values, submitInterview);
  };

  render() {
    const {children, currentUser, loading, profile,link,wrapWithLayout, view: Component, ...rest} = this.props;

    return <Component
      currentUser={currentUser}
      isOwner={currentUser && profile && currentUser.user && profile.user ? currentUser.user.id === profile.user.id : false}
      loading={loading}
      generate={generate}
      profile={profile}
      refresh={this.refresh}
      wrapWithLayout={wrapWithLayout ? wrapWithLayout : false}
      submit={this.submit}
      link={link}
      submitUserFreelance={this.submitUserFreelance}
      {...rest}
    >
      {children}
    </Component>;
  }
}

export default connect(
  (state) => ({}),
  (dispatch) => ({
    redirectToNotFound: () => dispatch(redirectToNotFound())
  })
)(StrategyFreelanceContainer);
